/*
 * Splendido — Sticky Add-to-Cart polyfill (v3 + retry)
 *
 * SPLENDIDO 2026-08-28 — due cose, dopo una misura sulla pagina vera a 375x812:
 *
 *  (a) IL CONTROLLER NATIVO DI PRESTIGE È ANCORA VIVO E VINCE SU DI NOI.
 *      `theme.js` definisce l'elemento <product-sticky-bar> e gli mette addosso un suo
 *      IntersectionObserver che accende/spegne LA STESSA classe `is-visible`. Il suo
 *      riferimento è `.shopify-section--footer`, cioè il footer Shopify originale, che noi
 *      abbiamo svuotato: misurato **alto 0px**, quindi non „interseca" mai → per lui la
 *      condizione footer è SEMPRE vera → a fondo pagina rimette la barra.
 *      (il 03/08 era stato tolto il doppione scritto dentro `main-product.liquid`; questo,
 *      che sta nel bundle del tema, era rimasto.)
 *      Misura a fondo pagina (scrollY 5642 = fondo): la NOSTRA condizione diceva
 *      correttamente „nascondi" (footer vero a top 288, dentro lo schermo), ma la barra
 *      restava visibile e copriva il selettore paese/lingua (top 733, bottom 759).
 *      ➜ Rimedio: la nostra decisione viene scritta anche come **stile in linea con
 *      `!important`**: chiunque altro rimetta `is-visible`, non si vede più.
 *      Non tocchiamo `theme.js` (è il bundle del tema, si riscrive a ogni aggiornamento).
 *      ⚠️ Lo stile in linea SEMPLICE non basta, provato a schermo: `splendido-spinner.css`
 *      (righe 178-185) dichiara `.product-sticky-bar.is-visible { opacity:1 !important;
 *      visibility:visible !important }`, e una regola `!important` di un foglio batte
 *      l'inline normale. Serve `setProperty(..., 'important')`, che invece vince su tutto.
 *      Chi un domani togliesse quegli `!important` dal CSS: qui non cambia niente.
 *
 *  (b) Richiesta del capo: dal blocco in basso la barra sparisce e **torna solo risalendo**.
 *      Serve anche da rete di sicurezza su mobile: quando la barra degli strumenti del
 *      browser si nasconde, `innerHeight` cambia e il footer può „uscire" dallo schermo per
 *      un attimo — senza il fermo la barra farebbe un lampeggio proprio lì.
 */
(function () {
  /* SPLENDIDO 2026-08-03: guardia anti-doppia inizializzazione (stesso pattern degli altri
     script Splendido). Se un giorno l'asset venisse incluso due volte, i listener e
     l'IntersectionObserver verrebbero registrati due volte sulla stessa barra. */
  if (window.__spStickyAtc) return;
  window.__spStickyAtc = true;

  function tryInit() {
    var bar = document.querySelector('.product-sticky-bar');
    if (!bar) return false;
    var formId = bar.getAttribute('form');
    var form = formId ? (document.getElementById(formId) || document.forms[formId]) : null;
    // Footer REALE (quello con i pagamenti): la barra sparisce quando si arriva in fondo.
    // SPLENDIDO 2026-08-03: il primo selettore era `[class*="shopify-section--ss-footer"]`, una
    // classe che NESSUNA sezione del tema emette (verificato sull'HTML servito) → si cadeva sempre
    // sul fallback `:last-of-type`, che dipende dall'ordine delle sezioni nel footer-group e si
    // sarebbe rotto al primo riordino. Ora si punta direttamente alla nostra sezione footer.
    var footer = document.querySelector('.shopify-section--sp-footer')
              || document.querySelector('.shopify-section-group-footer-group:last-of-type')
              || document.querySelector('.shopify-section--footer');
    if (!form || !footer) return false;

    // SPLENDIDO 2026-08-28 — fermo „sono arrivato in fondo".
    // RISALITA = quanti pixel bisogna tornare su perché la barra riappaia. Tenuto basso:
    // deve bastare un pollice, non deve sembrare che la barra „non torni più".
    var RISALITA = 24;
    var inFondo = false;   // il blocco in basso è stato raggiunto: barra ferma, spenta
    var suPx = 0;          // pixel risaliti di fila
    var ultimoY = window.pageYOffset;

    /* SPLENDIDO 2026-09-26 (audit PDP-03): al cambio di misura/metallo Prestige SOSTITUISCE
       l'intera barra (il suo <product-rerender> non ha `allow-partial-rerender`): il riferimento
       preso all'avvio restava a un elemento staccato dalla pagina e la barra nuova tornava al
       comportamento di serie (visibile anche sopra il footer). Ora barra e modulo si rileggono
       dalla pagina a ogni calcolo; se mancano, si usa quello di prima. */
    function barraAttuale() {
      return document.querySelector('.product-sticky-bar') || bar;
    }
    function moduloAttuale() {
      var id = barraAttuale().getAttribute('form') || formId;
      return (id && (document.getElementById(id) || document.forms[id])) || form;
    }

    function applica(should) {
      var bar = barraAttuale();
      bar.classList.toggle('is-visible', should);
      // Stile in linea = ultima parola nostra. Serve contro il controller nativo di Prestige,
      // che rimette `is-visible` a fondo pagina (vedi nota (a) in cima al file).
      // `!important` in linea: è l'unico livello che sta sopra a `splendido-spinner.css`,
      // che accende la barra con `!important` appena vede la classe `is-visible`.
      bar.style.setProperty('opacity', should ? '1' : '0', 'important');
      bar.style.setProperty('visibility', should ? 'visible' : 'hidden', 'important');
      // A barra spenta niente clic „fantasma" sopra footer e selettore lingua.
      bar.style.setProperty('pointer-events', should ? 'auto' : 'none', 'important');
    }

    function computeAndApply() {
      // SPLENDIDO 2026-06-25: su DESKTOP la sticky parte solo dopo "Können wir helfen?" (.splendido-help);
      // su MOBILE resta come prima (riferimento = form).
      var spDesk = window.matchMedia('(min-width: 1000px)').matches;
      var spHelp = document.querySelector('.splendido-help');
      var spRef = (spDesk && spHelp) ? spHelp : moduloAttuale();
      // Use bounding rects (reliable, no scroll-event dependency)
      var fr = spRef.getBoundingClientRect();
      var ftr = footer.getBoundingClientRect();

      // direzione: accumula solo la risalita, il primo pixel verso il basso azzera
      var y = window.pageYOffset;
      var dy = y - ultimoY;
      if (dy < 0) { suPx += -dy; } else if (dy > 0) { suPx = 0; }
      ultimoY = y;

      // „blocco in basso" = il footer vero (quello con contatti e selettore paese/lingua),
      // non appena entra anche solo per un pixel nello schermo.
      var fondoRaggiunto = ftr.top <= window.innerHeight;
      if (fondoRaggiunto) {
        inFondo = true;
        suPx = 0;
      } else if (inFondo && suPx >= RISALITA) {
        inFondo = false;
      }

      var should = fr.bottom < 0 && !fondoRaggiunto && !inFondo && !coperta();
      applica(should);
    }

    /* SPLENDIDO 2026-09-26 (audit NAV-07, ok capo): la barra resta nascosta mentre è aperto il menu del
       telefono, il cassetto del carrello o la finestra paese „Sind Sie in Deutschland?". Le regole CSS
       che la nascondevano (html.sp-menu-open) perdevano contro lo stile in linea `!important` messo qui
       sopra: ora la decisione passa da qui. Si ascolta solo l'attributo `class` di <html> (niente sottoalbero). */
    function coperta() {
      var c = document.documentElement.classList;
      return c.contains('sp-menu-open') || c.contains('sp-cart-open') || c.contains('sp-land-open');
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function () { window.requestAnimationFrame(computeAndApply); })
        .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }

    // IntersectionObserver: triggers when form or footer cross viewport boundary
    var io = new IntersectionObserver(function () {
      computeAndApply();
    }, { threshold: 0 });
    io.observe(form);
    io.observe(footer);

    // Fallback also on scroll (some themes use scroll-container)
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function () { computeAndApply(); ticking = false; });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    /* SPLENDIDO 2026-08-03: il resize passa dallo stesso freno a tempo dello scroll (rAF).
       Prima ricalcolava a ogni singolo evento: su mobile il resize scatta ogni volta che la
       barra degli strumenti del browser si nasconde o ricompare durante lo scorrimento, quindi
       erano misure di layout ripetute nel momento peggiore. */
    window.addEventListener('resize', onScroll, { passive: true });
    /* SPLENDIDO 2026-09-26 (audit PDP-03): subito dopo il cambio di variante la barra appena
       sostituita riceve la nostra decisione, senza aspettare il prossimo scorrimento.
       `variant:change` è l'evento che Prestige emette DOPO aver sostituito i blocchi. */
    document.addEventListener('variant:change', function () {
      window.requestAnimationFrame(computeAndApply);
    });

    // SPLENDIDO 2026-07-30 (audit): rimosso il setInterval 200ms — IO + scroll(rAF) + resize
    // coprono tutti i casi; il polling causava 10 forced-reflow/sec per tutta la vita della PDP.

    computeAndApply();
    return true;
  }

  // Multiple attempts to handle late-render of custom elements/sections
  function bootstrap() {
    if (tryInit()) return;
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (tryInit() || attempts > 20) clearInterval(interval);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
